import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stripNl'
})
export class StripNlPipe implements PipeTransform {

  transform(value: string): string {
    return value ? value.replace(/(?:\r\n|\r|\n)/g, ' ') : null;
  }
}
